import { batch } from 'react-redux';
import { PaperReceiptMode } from '../../common/enumerations/paper-receipt-mode';
import { IReceiptArgs } from '../../common/interfaces/dtos/IReceiptArgs';
import { store } from '../../common/redux/configure-store';
import { TenderingActions } from '../../common/redux/reducers/tendering-reducer';
import { finishTransaction } from '../../home-page/business-logic/finish-transaction';
import { makeTenderPayment } from '../../home-page/business-logic/make-tender-payment';
import { EmeraldError } from '../../common/api/emerald-error';
import { getReceiptDetails } from '../../tendering/components/receipt-modals/print-receipt-options';
import XLRLogger from '../../common/helpers/logger';
import { ITenderAdd } from '../../common/interfaces/dtos/IPreTenderAdd';
import { createSpan, endSpan } from 'src/common/helpers/tracing-helper';
import { SpanStatusCode } from '@opentelemetry/api';

let _lastTender: ITenderAdd = {};
let _shouldPrintPaperReceipt: boolean;
let _isFinishTransaction: boolean;

const finalizeTransaction = async (
  isPrintReceipt: boolean,
  receiptArgs: IReceiptArgs,
): Promise<void> => {
  const span = createSpan('finalize-transaction');
  if (_isFinishTransaction) {
    await finishTransaction(isPrintReceipt, receiptArgs, true);
  } else {
    //showSpinnerModal(); // As we are now using modal manager to show / hide the thank you view, we will need to rethink / rework the spinner logic
    try {
      await makeTenderPayment(_lastTender, isPrintReceipt, receiptArgs);
    } finally {
      //hideSpinnerModal();
    }
  }
  endSpan(span);
};

export const handleDigitalReceiptPreference = async (
  lastTender: ITenderAdd,
  drError: EmeraldError,
  isFinishTransaction?: boolean,
): Promise<void> => {
  const span = createSpan('handle-digital-receipt-preference');
  return new Promise((resolve, reject) => {
    _lastTender = lastTender;
    _shouldPrintPaperReceipt = drError.data.paperReceiptPolicy !== PaperReceiptMode.Never;
    _isFinishTransaction = !!isFinishTransaction;

    batch(
      async (): Promise<void> => {
        store.dispatch(
          TenderingActions.setDigitalReceiptOptions({
            emailRequested: drError.data.digitalReceiptEmailRequested,
            phoneRequested: drError.data.digitalReceiptPhoneRequested,
            paperReceiptMode: drError.data.paperReceiptPolicy as PaperReceiptMode,
            showCustomerContactData: drError.data.shouldShowCustomerContactData,
          }),
        );

        let receiptDetails: IReceiptArgs = {};

        try {
          receiptDetails = await getReceiptDetails();
        } catch (error) {
          XLRLogger.error({
            message: 'Error while getting receipt details.',
            source: 'handle-receipt-preference.ts',
            data: error,
          });
          receiptDetails = {};
        }

        const receiptArgs: IReceiptArgs = { ...receiptDetails, receiptDeliveryPreference: 'Print' };
        try {
          await finalizeTransaction(
            (receiptArgs.printReceipt ?? false) && _shouldPrintPaperReceipt,
            receiptArgs,
          );
        } catch (error) {
          span.setStatus({
            code: SpanStatusCode.ERROR,
            message: 'handleDigitalReceiptPreference error',
          });
          endSpan(span);
          reject(error);
        }
        endSpan(span);
        resolve();
      },
    );
  });
};
